import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { first } from 'lodash-es';
import { WindowEventsService } from '@nimbus-library/features/shared/services/window-events.service';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'nimbus-filter-text-input',
  templateUrl: './nimbus-filter-text-input.component.html',
  styleUrls: ['./nimbus-filter-text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterTextInputComponent implements AfterViewInit {
  @ViewChild('searchInput')
  public searchInput: ElementRef<HTMLInputElement>;

  @Input() public focusable: boolean = true;
  @Input() public initialFilterValue: string[];

  @Output() public valueChanged: EventEmitter<string> = new EventEmitter();

  public ICONS = ICONS;
  public TranslationKeys = TranslationKeys;

  public searchControl: FormControl<string> = new FormControl<string>('');

  public constructor(private readonly windowEventsService: WindowEventsService) {}

  public ngAfterViewInit(): void {
    this.windowEventsService
      .getKeyDown$()
      .pipe(untilDestroyed(this))
      .subscribe((x) => this.onSearchControlKeyUpDown(x));
    this.windowEventsService
      .getKeyUp$()
      .pipe(untilDestroyed(this))
      .subscribe((x) => this.onSearchControlKeyUpDown(x));

    const initialFilterValue = first(this.initialFilterValue || []);
    if (initialFilterValue?.length) {
      this.searchControl.setValue(initialFilterValue);
    }

    this.searchInput?.nativeElement?.focus();
  }

  public onRemoveSearch(): void {
    this.searchControl.setValue(null);
  }

  private onSearchControlKeyUpDown(event: KeyboardEvent): void {
    if (event.keyCode !== ENTER) {
      return;
    }
    this.valueChanged.emit(this.searchControl.value);
  }
}
